/**
 * Title, description and canonical URL, per page.
 *
 * index.html once carried `<link rel="canonical" href="https://sulje.com/">`
 * for every route — which tells a search engine that every project landing
 * page is a duplicate of the home page, and to index none of them. So the
 * canonical is set per route here: the router resets it on every navigation
 * (the path, without query: `?tool=` is attribution, not a different page),
 * and a landing page refines title and description once its data arrives.
 */
const SITE = 'https://sulje.com';

export const DEFAULT_TITLE = 'Sulje — bug reports, feature requests and support for Puida products';
export const DEFAULT_DESCRIPTION =
  'The Puida customer community: report bugs, vote on features and ask questions where the people who build Lasti, Hinguere, Sulle, Tapelang and Tilus read them. 9 € / month.';

function meta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.content = content;
}

export function setPageMeta(page: { path: string; title?: string; description?: string }) {
  const title = page.title ?? DEFAULT_TITLE;
  const description = page.description ?? DEFAULT_DESCRIPTION;
  const url = `${SITE}${page.path}`;

  document.title = title;
  meta('name', 'description', description);
  meta('property', 'og:title', title);
  meta('property', 'og:description', description);
  meta('property', 'og:url', url);

  let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  link.href = url;
}
